import { Component, OnDestroy, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { UserService } from 'src/app/services/user/user.service';

@Component({
  selector: 'app-list',
  templateUrl: './list.component.html',
  styleUrls: ['./list.component.sass']
})
export class ListComponent implements OnInit, OnDestroy {
  users: Array<any>
  _users: Array<any>

  userServiceSub: Subscription;

  constructor(
    private userService: UserService,
    ) { }

  ngOnInit(): void {
    this.users = this._users = []
    this.getUsers()
  }

  getUsers() {
    this.userServiceSub = this.userService.findAllByGroup().subscribe(res => {
      this._users = res.data
    });
  }

  ngOnDestroy() {
    this.userServiceSub.unsubscribe()
  }
}
